import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import DropDown from '../../../../../../components/formFields/DropDown'
import { GetAccredationsLookup } from '../../../../../../api/endpoints/Accredations'
import SectionCard from '../shared/SectionCard'
import './style.css'
import { FileUploadField } from '../shared'
import ImgPopup from '@/components/popups/imgPopup'
import {  Block, Inline } from '@/components/crRender'

const EditAccreditations = ({ formHandler, providerInfo, isLoading }) => {

    const { t } = useTranslation()

    const accreditations = useMemo(() => {
        return formHandler?.formValues?.["accredationIds"]?.value.map(accredation => ({ label: accredation.label, value: accredation.value }))
    }, [providerInfo ,formHandler])

    const updateAccredation = (accredation, name, value) => {
        let newValue =
            formHandler?.formValues?.accredetationsImgs?.filter(e => e.name != name) || []

        formHandler?.handleFormValues("accredetationsImgs",
            [...newValue, { name: name, value: accredation, prevId: value }]
        )
    }

    const accredetationsImgs = (label) => {
        let file = providerInfo?.files?.find(e => e.name == label)?.data
        let data = file?.[file?.length - 1]
        return data
    }



    return (
        <SectionCard
            title={t("accreditations-services")}
            icon="mingcute:certificate-fill"
            className="edit-accreditations"
        >
            <DropDown
                isLoading={isLoading}
                className="col-md-12"
                label={"accredationIds"}
                isMulti={true}
                endPoint={GetAccredationsLookup}
                defaultValue={providerInfo?.accredations}
                formHandler={formHandler} />
            <div className="row">
                {accreditations?.map((accredation, index) => (

                    <div className="col-md-6 mb-3" key={index}>
                        <div className="row align-items-center">
                            <ImgPopup sourcePath={window.API_URL}
                                link={accredetationsImgs(accredation.label)?.name} />
                            <Block isRender={true} className="accredation-label">{" "}{accredation.label}</Block>
                        </div>
                        <FileUploadField
                            className="col-md-6"
                            formHandler={(name, value) => updateAccredation(value, accredation?.label, accredetationsImgs(accredation.label)?.id)}
                            name="picture"
                            id={`technology-picture-${accredation.value}`}
                            accept="image/*"
                            maxFiles={1}
                            value={formHandler?.formValues?.files?.findFirstValue("name", accredation.label)?.["data"][0]?.name}
                        />
                    </div>
                ))}
            </div>

        </SectionCard>
    )
}

export default EditAccreditations

